module.exports = __webpack_public_path__ + "static/media/dolly-flatbed.86233aba.svg";